module.exports = __webpack_public_path__ + "img/yh_01.1dff29ec.png";